/* eslint-disable */
import { MenuItem, Select } from "@mui/material";

const CustomFormEquipmentSelect = ({name, value, register, id, requiredMessage, list, onChange, onChangeProp,  ...restProps}) => {
    const handleChange = (e) => {
        const newValue = e?.target?.value ?? e;
// console.log(e?.target?.value)
// console.log(e)
        // react-hook-form 연결
        if (onChange) {
            // console.log(111)
            onChange(newValue);
        }

        // 외부 onChangeProp 처리
        if (onChangeProp) {
            if (typeof onChangeProp === "function") {
                // (e) => setVal(e.target.value)
                if (onChangeProp.length > 0) {
                    onChangeProp({ target: { value: newValue } });
                } else {
                    // (value) => setVal(value)
                    onChangeProp(newValue);
                }
            }
        }
    };
    
    return (
        <Select
            {...restProps}
            value={value ?? ''}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                PaperProps: {
                    sx: {
                        transform: 'translateX(5px)',
                    },
                },
            }}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            {...register(name, {
                required : requiredMessage
            })}
            onChange={handleChange}
        >
            <MenuItem 
            disabled
            sx={{display : 'none'}}
            key="empty"
            value={''}>
                <em>None</em>
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
                {opt.name}
            </MenuItem> 
            ))}
        </Select>
    );
};

export default CustomFormEquipmentSelect;